import * as haversine from "haversine";
export function distanceTo(startingCoordinates, endingCoordinates) {
    var start = {
        latitude: startingCoordinates[0],
        longitude: startingCoordinates[1],
    };
    var end = {
        latitude: endingCoordinates[0],
        longitude: endingCoordinates[1],
    };
    var metricDistance = haversine(start, end, { unit: "km" });
    var imperialDistance = haversine(start, end, { unit: "mile" });
    return {
        imperial: {
            amount: imperialDistance.toFixed(2),
            unit: "miles",
        },
        metric: {
            amount: metricDistance.toFixed(2),
            unit: "km",
        },
    };
}
function readCookie(name) {
    var c = [];
    if (typeof document !== "undefined" && document.cookie) {
        c = document.cookie.split("; ");
    }
    var cookies = {};
    c.forEach(function (cookie) {
        var cookieValue = cookie.split("=");
        cookies[cookieValue[0]] = cookieValue[1];
    });
    return cookies[name];
}
export function distanceUnits() {
    if (readCookie("lpCurrency") === "USD") {
        return "imperial";
    }
    return "metric";
}



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/utils/distanceTo.ts
// module id = WxNj
// module chunks = 2